import * as React from 'react'

export const CloseMenuIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="5"
    height="10"
    viewBox="0 0 5 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.10524 9.82308L0.171947 5.3942C0.06448 5.25507 5.82418e-08 5.11594 5.99009e-08 4.97682C6.15599e-08 4.83769 0.0429872 4.72175 0.12896 4.60581L4.06225 0.176893C4.27718 -0.0549535 4.59958 -0.0549535 4.79302 0.153743C5.00795 0.362438 5.00795 0.710293 4.81451 0.94214L1.24662 4.97682L4.8575 9.05788C5.05094 9.26657 5.05094 9.63758 4.836 9.84627C4.62108 10.055 4.29867 10.055 4.10524 9.82308Z"
      fill="#282421"
    />
  </svg>
)
